<template>
  <div class="video-courses-page">
    <el-card class="vc-header">
      <el-button type="text" icon="el-icon-arrow-left" @click="$emit('switch-view', 'MemberCenter')" style="margin-bottom:10px;">
        返回会员中心
      </el-button>
      <div class="vc-header-row">
        <el-input v-model="search" placeholder="搜索视频课程" class="vc-search" clearable @keyup.enter.native="fetchData" />
        <el-select v-model="category" placeholder="全部分类" class="vc-select" @change="fetchData">
          <el-option label="全部分类" value="" />
          <el-option v-for="cat in categories" :key="cat" :label="cat" :value="cat" />
        </el-select>
      </div>
    </el-card>
    <el-card class="vc-list-card">
      <el-row :gutter="18">
        <el-col :xs="24" :sm="12" :md="8" v-for="video in videoList" :key="video.id">
          <el-card class="vc-item">
            <el-image :src="video.cover" class="vc-img" fit="cover" />
            <div class="vc-info">
              <div class="vc-title">{{ video.title }}</div>
              <div class="vc-desc">{{ video.desc }}</div>
              <div class="vc-btns">
                <el-button size="mini" type="primary" @click="play(video)">播放</el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        @current-change="fetchData"
        class="vc-pagination"
      />
    </el-card>
    <el-dialog :visible.sync="showPlayer" width="720px" :title="playVideo.title">
      <video v-if="playVideo.src" :src="playVideo.src" controls style="width:100%" />
      <div v-else style="color:#888;">暂无视频资源</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'VideoCourses',
  data() {
    return {
      search: '',
      category: '',
      categories: ['动物套件', '文创产品', '建筑套件', '卡通人物', '文创产品'],
      videoList: [],
      page: 1,
      pageSize: 6,
      total: 0,
      showPlayer: false,
      playVideo: {},
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      // 与激光切割机相关的文创课程视频示例
      const all = [
        { id: 1, cover: '/img/his1.jpg', title: '激光切割机动物拼装教学', desc: '动物拼装套件制作与教学', src: '/video/laser_animal.mp4', type: '动物套件' },
        { id: 2, cover: '/img/his2.jpg', title: '激光切割机文创钥匙扣制作', desc: '钥匙扣设计与切割流程', src: '/video/laser_keychain.mp4', type: '文创产品' },
        { id: 3, cover: '/img/his3.jpg', title: '激光切割机建筑模型课程', desc: '建筑模型套件制作与教学', src: '/video/laser_building.mp4', type: '建筑套件' },
        { id: 4, cover: '/img/his4.jpg', title: '激光切割机卡通人物拼装', desc: '卡通人物拼装设计与教学', src: '/video/laser_cartoon.mp4', type: '卡通人物' },
        { id: 5, cover: '/img/his5.jpg', title: '激光切割机创意灯具制作', desc: '灯具文创产品制作与教学', src: '/video/laser_lamp.mp4', type: '文创产品' },
        { id: 6, cover: '/img/his6.jpg', title: '激光切割机动物面具课程', desc: '动物面具套件制作与教学', src: '/video/laser_mask.mp4', type: '动物套件' },
        { id: 7, cover: '/img/his7.jpg', title: '激光切割机创意台历课程', desc: '台历文创产品制作与教学', src: '/video/laser_calendar.mp4', type: '文创产品' },
      ];
      let filtered = all.filter(item => {
        const matchSearch = !this.search || item.title.includes(this.search);
        const matchCat = !this.category || item.type === this.category;
        return matchSearch && matchCat;
      });
      this.total = filtered.length;
      const start = (this.page - 1) * this.pageSize;
      this.videoList = filtered.slice(start, start + this.pageSize);
    },
    play(video) {
      this.playVideo = video;
      this.showPlayer = true;
    },
  }
};
</script>

<style scoped>
.video-courses-page {
  max-width: 1050px;
  margin: 0 auto;
  padding: 32px 0;
}
.vc-header {
  margin-bottom: 18px;
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
}
.vc-header-row {
  display: flex;
  align-items: center;
  gap: 18px;
}
.vc-search {
  width: 260px;
}
.vc-select {
  width: 160px;
}
.vc-list-card {
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
  margin-bottom: 18px;
}
.vc-item {
  display: flex;
  gap: 16px;
  border-radius: 8px;
  margin-bottom: 18px;
  min-height: 120px;
  padding-left: 45px;
}
.vc-img {
  width: 96px;
  height: 96px;
  border-radius: 8px;
  object-fit: cover;
}
.vc-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.vc-title {
  font-size: 16px;
  font-weight: 500;
}
.vc-desc {
  font-size: 13px;
  color: #888;
  margin: 8px 0;
}
.vc-btns {
  display: flex;
  gap: 8px;
  /* display: flex; */
  justify-content: center;
  align-items: center;
}
.vc-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
